import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuthUser } from "hooks/useAuthUser";

const PublicRoutes = () => {
  const { isAuthenticated } = useAuthUser();

  return !isAuthenticated ? <Outlet /> : <Navigate to="/home" replace />;
};

export default PublicRoutes;
